var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { publish } from 'conversional-callbacks';
import { Events, JourneysSelectors, ProcessesSelectors, TrackingActions, useAppDispatch, useAppSelector } from 'conversional-journey';
import QuestionContainer from './QuestionContainer';
import ImageOptions from './ImageOptions';
import { withConditionals } from '../../utilities/hoc/conditionals';
import { getStyles } from './SingleImageSelect.styles';
var QuestionSingleImageSelect = function (props) {
    var _a = useState(null), selected = _a[0], setSelected = _a[1];
    var avatarOnTopLayout = props.avatarOnTopLayout, blackBackgroundOnTitle = props.blackBackgroundOnTitle, cardStyles = props.cardStyles, componentKey = props.componentKey, gridConfiguration = props.gridConfiguration, imageAspectRatio = props.imageAspectRatio, _b = props.mobileOptions, mobileOptions = _b === void 0 ? [] : _b, mobileSvgWidth = props.mobileSvgWidth, _c = props.options, options = _c === void 0 ? [] : _c, questionKey = props.questionKey, subTitleOnImage = props.subTitleOnImage, svgBackgroundColor = props.svgBackgroundColor, svgContainerStyles = props.svgContainerStyles, svgDimensions = props.svgDimensions, svgFillColor = props.svgFillColor, svgStrokeColor = props.svgStrokeColor, titleOnImage = props.titleOnImage, forceUseCustomGrid = props.forceUseCustomGrid;
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var processStep = useAppSelector(ProcessesSelectors.selectCurrentProcessStep);
    var classes = getStyles(theme);
    var onClick = function (value) {
        var _a;
        setSelected(value);
        publish('Question.selected', (_a = {}, _a[questionKey] = value, _a), componentKey);
        trackEvent(__assign(__assign({}, Events.ANSWER_CLICKED), { label: value || 'undefined', meta: {
                questionKey: questionKey,
                processStep: processStep
            } }));
    };
    var debouncedOnClick = useCallback(debounce(onClick, 200), []);
    var renderCards = function () {
        return (_jsx(ImageOptions, { aspectRatio: imageAspectRatio, 
            // Deprecate for the time being till adding the support in DRY questions
            // avatarOnTopLayout={avatarOnTopLayout}
            blackBackgroundOnTitle: blackBackgroundOnTitle, cardStyles: cardStyles, gridConfiguration: gridConfiguration, forceUseCustomGrid: forceUseCustomGrid, isSelected: function (option) { return selected === option.value; }, mobileOptions: mobileOptions, mobileSvgWidth: mobileSvgWidth, onClick: function (option) { return debouncedOnClick(option.value || option.title); }, options: options, subTitleOnImage: subTitleOnImage, svgBackgroundColor: svgBackgroundColor, svgContainerStyles: svgContainerStyles, svgDimensions: svgDimensions, svgFillColor: svgFillColor, svgStrokeColor: svgStrokeColor, titleOnImage: titleOnImage, questionKey: questionKey }));
    };
    if (!isEmpty(theme.breakpoints)) {
        var _d = theme.breakpoints, xs = _d.xs, sm = _d.sm, md = _d.md, lg = _d.lg, xl = _d.xl;
        var muiBreakpoints = {
            values: {
                xs: xs.min,
                sm: sm.min,
                md: md.min,
                lg: lg.min,
                xl: xl.min
            }
        };
        var customThemeWithBreakpoints = createTheme({
            breakpoints: muiBreakpoints
        });
        return (_jsx(ThemeProvider, { theme: customThemeWithBreakpoints, children: _jsx("div", { children: _jsx(QuestionContainer, __assign({ questionTextBoxContainerClassName: classes.singleImageSelectTextBoxContainer }, props, { children: renderCards() })) }) }));
    }
    return (_jsx("div", { children: _jsx(QuestionContainer, __assign({ questionTextBoxContainerClassName: classes.singleImageSelectTextBoxContainer }, props, { children: renderCards() })) }));
};
export default withConditionals(QuestionSingleImageSelect, {
    conditionalArray: {
        arrayPropName: "options"
    }
});
